// The actor came back through a win-back or finish-later email (Signup/docs/34 §3b, docs/35 S5).
// Each email's link carries eref, its send row signed by the server; the page reports it once and
// the server stamps that email's return. Reported by the page, not by opening the link, so mail
// scanners that open links don't count. Never waited on, never shown, never breaks the page.

import { getSubmissionFlowApi } from "../../../shared/api/submission";

export const EMAIL_REF_PARAM = "eref";
const STORAGE_KEY = "sfEmailRefsReported";

const reportedRefs = (): string[] => {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
};

const remember = (eref: string) => {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(reportedRefs().concat(eref).slice(-20)));
  } catch (e) {
    // Private mode: the server's own "first return only" keeps it to one stamp.
  }
};

/** Reports the eref on the link, once per tab; true when the link had one. */
export const reportEmailReturn = (search: string): boolean => {
  let eref: string | null = null;
  try {
    eref = new URLSearchParams(search || "").get(EMAIL_REF_PARAM);
  } catch (e) {
    eref = null;
  }
  if (!eref) return false;
  if (reportedRefs().indexOf(eref) < 0) {
    remember(eref);
    try {
      getSubmissionFlowApi().winBackReturn(eref).catch(() => undefined);
    } catch (e) {
      // Never breaks the page.
    }
  }
  return true;
};

/** The search without eref (it has done its job once reported). */
export const withoutEmailRef = (search: string): string => {
  try {
    const params = new URLSearchParams(search || "");
    if (!params.has(EMAIL_REF_PARAM)) return search || "";
    params.delete(EMAIL_REF_PARAM);
    const out = params.toString();
    return out ? `?${out}` : "";
  } catch (e) {
    return search || "";
  }
};
